import { render, staticRenderFns } from "./muokkaa-kurssikoodia.vue?vue&type=template&id=8902c9b8&scoped=true&"
import script from "./muokkaa-kurssikoodia.vue?vue&type=script&lang=ts&"
export * from "./muokkaa-kurssikoodia.vue?vue&type=script&lang=ts&"
import style0 from "./muokkaa-kurssikoodia.vue?vue&type=style&index=0&id=8902c9b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8902c9b8",
  null
  
)

export default component.exports